export const ACTION = {
  INSERT: 'YENİ KAYIT',
  UPDATE: 'GÜNCELLENDİ',
  DELETE: 'SİLİNDİ',
  NONE:   'DOKUNULMADI',
};

export const STAT_LABELS = [
  { key: 'before',   label: 'İşlem öncesi toplam hat sayısı' },
  { key: 'after',    label: 'İşlem sonrası toplam hat sayısı' },
  { key: 'inserted', label: 'Yeni eklenen hat sayısı' },
  { key: 'updated',  label: 'Güncellenen hat sayısı' },
  { key: 'deleted',  label: 'Silinen hat sayısı' },
];

function emptyStats() {
  return { before: 0, after: 0, inserted: 0, updated: 0, deleted: 0 };
}

function isFilled(value) {
  return value !== null && value !== undefined && String(value).trim() !== '';
}

function normalizeOperator(value) {
  const text = isFilled(value) ? String(value).trim().toLocaleUpperCase('tr-TR') : '';
  return text || 'BİLİNMİYOR';
}

export function summarizeMerge(rows) {
  // Ayni GSM cihaz join'i yuzunden birden fazla satirda gelebilir, her hatti bir kez say
  const unique = new Map();
  (rows || []).forEach(row => {
    if (!unique.has(row.GSMNO)) unique.set(row.GSMNO, row);
  });

  const total = emptyStats();
  const byOperator = new Map();
  const statsFor = op => {
    if (!byOperator.has(op)) byOperator.set(op, emptyStats());
    return byOperator.get(op);
  };

  unique.forEach(row => {
    const action = row.MERGE_ACTION;
    const oldOp = normalizeOperator(row.OLD_OPERATOR);
    const newOp = normalizeOperator(isFilled(row.NEW_OPERATOR) ? row.NEW_OPERATOR : row.OLD_OPERATOR);

    const existedBefore = action !== ACTION.INSERT;
    const existsAfter   = action !== ACTION.DELETE;

    if (existedBefore) { total.before++; statsFor(oldOp).before++; }
    if (existsAfter)   { total.after++;  statsFor(newOp).after++;  }

    switch (action) {
      case ACTION.INSERT: total.inserted++; statsFor(newOp).inserted++; break;
      case ACTION.UPDATE: total.updated++;  statsFor(newOp).updated++;  break;
      case ACTION.DELETE: total.deleted++;  statsFor(oldOp).deleted++;  break;
      default: break; // DOKUNULMADI
    }
  });

  const operators = Array.from(byOperator.entries())
    .map(([operator, stats]) => Object.assign({ operator }, stats))
    .sort((a, b) => a.operator.localeCompare(b.operator, 'tr-TR'));

  return { total, operators };
}


// WEBPACK FOOTER //
// ./src/utils/mergeSummary.js